import React from "react";
import styled from "styled-components";
import { useSelector, useDispatch } from "react-redux";
import { UserOutlined, NumberOutlined } from "@ant-design/icons";
import { Form, Row, Col, Radio, Spin } from "antd";
import { Input, Select, RadioGroup, Button, Typography } from "../core";
import { addProgramReg } from "../redux/Action/Sizer/addProgram";
// import { Space } from "antd";
import { MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";
import { MixStyle } from "../styles";
import { getCompanyId } from "../helper/utils/companyId";
const Notify_Utils = require("../helper/utils/Notification");

const layout = {
  labelCol: {
    span: 24,
  },
  wrapperCol: {
    span: 24,
  },
};
const StyledForm = styled(Form)`
  label {
    ${MixStyle.Label};
  }
`;

const AddProgramForm = ({ sizerId }) => {
  const { token } = useSelector((state) => state.auth);
  let Error = useSelector((state) => state.errorReducer);

  const dispatchToAction = useDispatch();
  const [addProgram, setAddProgram] = React.useState({});
  // const YarnQualityOption = useSelector(
  //   (state) => state.yarnQualityReducer.yarnQuality
  // );
  const sizerList = useSelector((state) => state.sizer.sizer);

  const yarnQuality = useSelector(
    (state) => state.yarnQualityReducer.yarnQuality
  );
  const [form] = Form.useForm();
  const onFinish = (values) => {
    console.log("addProgram", addProgram);
    dispatchToAction(addProgramReg(addProgram));
  };
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };
  const onValuesChange = (changed, values) => {
    const {
      sizer_id,
      tar,
      back_beam,
      beam_size,
      final_beam,
      yarn_quality_id,
      bags_add_program,
      cons_add_program,
      beam_delivered,
    } = values;
    sizerId[1](sizer_id);
    // sizerId[1](sizer_id);

    setAddProgram((prev) => ({
      ...prev,
      company_id: getCompanyId(),
      sizer_id,
      tar,
      back_beam,
      beam_size,
      final_beam,
      yarn_quality_id,
      bags_add_program,
      cons_add_program,
      beam_delivered,
      token: token,
    }));
  };
  return (
    <React.Fragment>
      {Error.id === "ADD_PROGRAM_FAIL" ? (
        Object.values(Error.msg).map((items, index) => {
          return Notify_Utils.openNotificationWithIcon(
            "error",
            `${items[0]}`,
            "white"
          );
        })
      ) : Error.id === "ADD_PROGRAM_SUCCESS" ? (
        <>
          {Notify_Utils.openNotificationWithIcon("success", Error.msg)},
          {form.resetFields()}
        </>
      ) : null}
      <StyledForm
        autocomplete="off"
        form={form}
        {...layout}
        name="basic"
        initialValues={{
          remember: true,
        }}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        onValuesChange={onValuesChange}
      >
        <Row
          gutter={{ xs: 0, sm: 48, md: 48, lg: 48 }}
          type="flex"
          justify="center"
        >
          <Col sm={18} xs={22}>
            <Form.Item
              label="Sizer Name"
              name="sizer_id"
              rules={[
                {
                  required: true,
                  message: "Please select Sizer Name",
                },
              ]}
            >
              <Select
                prefixIcon={<UserOutlined />}
                placeholder="Sizer name"
                type="sizerList"
                Options={sizerList ? sizerList : [<LazyLoad />]}
              />
            </Form.Item>
          </Col>
          <Col sm={18} xs={22}>
            <Form.Item
              label="Yarn Quality"
              name="yarn_quality_id"
              rules={[
                {
                  required: true,
                  message: "Please select Quality",
                },
              ]}
            >
              <Select
                prefixIcon={<NumberOutlined />}
                placeholder="Quality"
                type="yarnQualities"
                Options={yarnQuality ? yarnQuality : [<LazyLoad />]}
              />
            </Form.Item>
          </Col>
          <Col sm={18} xs={22}>
            <Row type="flex" justify="space-between" gutter={[16, 16]}>
              <Col xs={8}>
                <Form.Item
                  name="tar"
                  rules={[
                    {
                      required: true,
                      message: "Please Enter Tar",
                    },
                  ]}
                >
                  <Input className="text-center" placeholder="Tar" />
                </Form.Item>
              </Col>
              <Col xs={8}>
                <Form.Item
                  name="back_beam"
                  rules={[
                    {
                      required: true,
                      message: "Please Enter back beam!",
                    },
                  ]}
                >
                  <Input className="text-center" placeholder="Back Beam" />
                </Form.Item>
              </Col>
              <Col xs={8}>
                <Form.Item
                  name="beam_size"
                  rules={[
                    {
                      required: true,
                      message: "Please Enter Beam Size",
                    },
                  ]}
                >
                  <Input className="text-center" placeholder="Beam Size" />
                </Form.Item>
              </Col>
            </Row>
          </Col>
          <Col sm={18} xs={22}>
            <Form.Item
              name="final_beam"
              rules={[
                {
                  required: true,
                  message: "Please Enter Final Beam",
                },
              ]}
            >
              <Input placeholder="Final Beam" />
            </Form.Item>
          </Col>
          <Col sm={16} xs={22}>
            <Form.List name="departmensts">
              {(fields, { add, remove }) => {
                return (
                  <div>
                    <Typography
                      align="center"
                      weight="bold"
                      color="#233B67"
                      as="h3"
                    >
                      Yarn variations
                    </Typography>
                    {fields.map((field, index) => (
                      <div>
                        {fields.length > 0 ? (
                          <MinusCircleOutlined
                            className="dynamic-delete-button"
                            style={{ margin: "0 8px" }}
                            onClick={() => {
                              remove(field.name);
                            }}
                          />
                        ) : null}
                        <Form.Item
                          {...field}
                          name={[field.name, "yarn_quality_id"]}
                          fieldKey={[field.fieldKey, "yarn_quality_id"]}
                          rules={[
                            {
                              required: false,
                              message: "Please select Quality",
                            },
                          ]}
                        >
                          <Select
                            prefixIcon={<NumberOutlined />}
                            placeholder="Quality"
                            type="yarnQualities"
                            Options={yarnQuality ? yarnQuality : [<LazyLoad />]}
                          />
                        </Form.Item>
                        <Row
                          type="flex"
                          justify="space-between"
                          gutter={[16, 16]}
                        >
                          <Col xs={12}>
                            <Form.Item
                              {...field}
                              name={[field.name, "bags_add_program"]}
                              fieldKey={[field.fieldKey, "bags_add_program"]}
                              rules={[
                                {
                                  required: false,
                                  message: "Please select Bags",
                                },
                              ]}
                            >
                              <Input
                                className="text-center"
                                placeholder="Bags"
                              />
                            </Form.Item>
                          </Col>
                          <Col xs={12}>
                            <Form.Item
                              {...field}
                              name={[field.name, "cons_add_program"]}
                              fieldKey={[field.fieldKey, "cons_add_program"]}
                              rules={[
                                {
                                  required: false,
                                  message: "Please Enter Number of Cones",
                                },
                              ]}
                            >
                              <Input
                                className="text-center"
                                placeholder="Cones"
                              />
                            </Form.Item>
                          </Col>
                        </Row>

                        {/* {fields.length > 0 ? (
                          <MinusCircleOutlined
                            className="dynamic-delete-button"
                            style={{ margin: "0 8px" }}
                            onClick={() => {
                              remove(field.name);
                            }}
                          />
                        ) : null} */}
                      </div>
                    ))}

                    <Form.Item>
                      <Button
                        width="150px"
                        margin="auto"
                        fontSize="16px"
                        weight="500"
                        height="auto"
                        bg="#ba3d79"
                        onClick={() => {
                          add();
                        }}
                      >
                        <PlusOutlined /> Yarn Variations
                      </Button>
                    </Form.Item>
                  </div>
                );
              }}
            </Form.List>
          </Col>
          {/* <Col sm={18} xs={22}>
            <Form.Item
              label="Yarn Quality"
              name="yarn_quality_id"
              rules={[
                {
                  required: true,
                  message: "Please select Quality",
                },
              ]}
            >
              <Select
                prefixIcon={<NumberOutlined />}
                placeholder="Quality"
                type="yarnQualities"
                Options={yarnQuality ? yarnQuality : [<LazyLoad />]}
              />
            </Form.Item>
          </Col> */}
          {/* <Col sm={18} xs={22}>
            <Row type="flex" justify="space-between" gutter={[16, 16]}>
              <Col xs={12}>
                <Form.Item
                  name="bags_add_program"
                  rules={[
                    {
                      required: true,
                      message: "Please Enter Number of Bags",
                    },
                  ]}
                >
                  <Input className="text-center" placeholder="Bags" />
                </Form.Item>
              </Col>
              <Col xs={12}>
                <Form.Item
                  name="cons_add_program"
                  rules={[
                    {
                      required: true,
                      message: "Please Enter Number of Cones",
                    },
                  ]}
                >
                  <Input className="text-center" placeholder="Cones" />
                </Form.Item>
              </Col>
            </Row>
          </Col> */}

          <Col sm={18} xs={22}>
            <Form.Item
              name="beam_delivered"
              label="Beam Delivered"
              rules={[
                {
                  required: true,
                  message: "Please Select one",
                },
              ]}
              // rules={[
              //   {
              //     validator: (_, value) =>
              //       value
              //         ? Promise.resolve()
              //         : Promise.reject("Please Select one"),
              //   },
              // ]}
            >
              <RadioGroup>
                <Radio value={true}>Yes</Radio>
                <Radio value={false}>No</Radio>
              </RadioGroup>
            </Form.Item>
          </Col>
          <Col sm={18} xs={22}>
            <Form.Item>
              <Button
                width="187px"
                bg="#404E67"
                type="primary"
                htmlType="submit"
              >
                <Typography
                  text="Add Program"
                  as="h5"
                  noMargin
                  weight="bold"
                  align="center"
                  color="white"
                />
              </Button>
            </Form.Item>
          </Col>
        </Row>
      </StyledForm>
    </React.Fragment>
  );
};

const LazyLoad = () => {
  return (
    <Spin style={{ display: "block", margin: "auto" }} tip="Loading..."></Spin>
  );
};
export default AddProgramForm;
